import React, {ReactNode} from 'react';

export interface PreventParentClickWrapperProps {
  children: ReactNode;
}

export default function PreventParentClickWrapper(props: PreventParentClickWrapperProps): JSX.Element {
  return (
    <span
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {props.children}
    </span>
  );
}
